import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TokenizedPaymentCard } from '@/models';

@Component({
  name: 'CmgGiftCard',
})
export default class CmgGiftCard extends Vue {
  isRemovingCard = false;
  balance = 0;
  isLoading = false;

  @Prop({ required: true, type: Object })
  token!: TokenizedPaymentCard;

  @Prop({ required: true, type: Boolean })
  showRemoveButton!: boolean;

  async mounted() {
    const giftCardBalance = this.$appStore.state.customer.wallet.giftCardBalances[this.token.tokenizedAccountNumber];

    if (giftCardBalance) {
      this.balance = giftCardBalance;
    } else {
      this.isLoading = true;
      try {
        this.balance = (await this.$services.transaction.getGiftCardBalance(this.token.tokenizedAccountNumber)).currentBalance || 0;
      } finally {
        this.isLoading = false;
      }
    }
  }

  get giftCardImgUrl(): string {
    return this.$appStore.state.cms.images.giftCard.default;
  }

  get medallionPepperImgUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionPepper.default;
  }

  get giftCardNumber(): string {
    // Put space between every 4 numbers
    const segmentList: RegExpMatchArray | null = this.token.tokenizedAccountNumber.match(/.{1,4}/g);

    if (!segmentList) {
      return '';
    }

    return segmentList.join(' ');
  }

  async onClickRemoveGiftCard(event: any) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('removePaymentCardModal', true, { token: this.token });
    this.$services.ui.firstFocus();
  }

  openGiftCardQR() {
    this.$services.ui.setModalVisibility('giftCardQr', true);
  }
}
